import {createFeatureSelector, createSelector} from '@ngrx/store';
import {SummaryState} from './summary.reducer';
import {SummaryDTO} from '../../dto/summary';

export const selectSummaryState = createFeatureSelector<SummaryState>('summary');

export const selectProjectSummaries = (projectId: number) => createSelector(
  selectSummaryState,
  (state: SummaryState) => state.projectSummary[projectId] ?? undefined,
);

export const selectProjectSummary = (projectId: number, summaryId: number) => createSelector(
  selectProjectSummaries(projectId),
  (state: SummaryDTO[]) => state ? state.find(summary => summary.id === summaryId) : undefined
);

export const selectPaperSummary = (paperId: number) => createSelector(
  selectSummaryState,
  (state: SummaryState) => state.paperSummary[paperId] ?? undefined,
);

export const selectPaperLoading = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.loadingForPaper
);

export const selectLoading = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.loading
);

export const selectGenerating = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.generating
);


export const selectSummaryProcessRunning = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.summaryProcessRunning
);


export const selectError = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.error
);

export const selectPaperError = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.errorForPaper
);


export const selectProjectNotFound = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.projectNotFound
);


export const selectSelectedSummary = createSelector(
  selectSummaryState,
  (state: SummaryState) => state.selectedSummary
);

export const selectPapersSummary = (summaryId: number) => createSelector(  // New selector for papers summary list
  selectSummaryState,
  (state: SummaryState) => state.papersSummaryBySummary[summaryId] ?? []
);

